import { render, staticRenderFns } from "./RequestPostProgressList.vue?vue&type=template&id=252146e2&scoped=true&"
import script from "./RequestPostProgressList.vue?vue&type=script&lang=js&"
export * from "./RequestPostProgressList.vue?vue&type=script&lang=js&"
import style0 from "./RequestPostProgressList.vue?vue&type=style&index=0&id=252146e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252146e2",
  null
  
)

export default component.exports